import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import FindingsPage from './pages/FindingsPage';
import FindingPage from './pages/FindingPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <FindingsPage />,
  },
  {
      path: 'new',
      element: <FindingPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <FindingPage />,
      },
    ],
  },
];

export default routes;
